/*
 * Copyright (c) 2020, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */

import { getOwnPropertyDescriptor, MapCreate } from '../shared/utils';

const assignedSlotOriginal = getOwnPropertyDescriptor(Text.prototype, 'assignedSlot')!.get!;

const assignedSlotDistortion = function assignedSlot(): HTMLSlotElement | null {
  return null;
};

export default MapCreate([[assignedSlotOriginal, assignedSlotDistortion]]);
